<button
  class="card-button"
  [ngClass]="[getButtonSize(), getButtonBackground()]"
  [class.card-button--warning]="warning"
  [disabled]="disabled"
  (click)="onClick()">
  @if (buttonIcon) {
    <fa-icon class="card-button__icon" [icon]="buttonIcon"></fa-icon>
  }
  @if (warning) {
    <fa-icon class="card-button__warning" [icon]="['fas', 'circle-exclamation']" [title]="'webPos.SobitPaymentUnavailable' | translate"></fa-icon>
  }
  <span class="card-button__content">
    <ng-content></ng-content>
  </span>
  
</button>
